<template>
  <banners
    :sticky-top="true"
    :narrow="true"
  >
    <div class="container-max mx-auto w-full px-4 py-6 text-left md:px-10">
      <p class="header-text mb-8 text-dark-blue">Account Overview</p>
      <show-profile />
    </div>
  </banners>
</template>

<script type="text/javascript">
import Banners from '@/components/Banners.vue';
import ShowProfile from '@/views/common/my-profile/ShowProfile.vue';

export default {
  name: 'Carrier My Profile',
  components: {
    Banners,
    ShowProfile,
  },
  created() {
    console.log('on MyProfile');
    //   const storage = localStorage.getItem("redirect_url_after_sigin");
    //   if (storage) {
    //     let redirectAfterSignIn = JSON.parse(
    //       localStorage.getItem("redirect_url_after_sigin")
    //     );

    //     if (redirectAfterSignIn) {
    //       localStorage.removeItem("redirect_url_after_sigin");
    //       return this.$router.push(redirectAfterSignIn);
    //     }
    //   }
  },
  beforeMount() {
    this.$store.dispatch(
      'ownership/getOwnershipByCompanyId',
      this.$store.state.users.currentUser?.company?.id
    );
  },
  computed: {
    userOwnership() {
      return (
        this.$store.state.ownership.ownershipData?.ownership_users?.find(
          (owner) => owner.user_id === this.$store.state.users.currentUser.id
        ) || null
      );
    },
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
}
</style>
